import { foundationFlipperStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { PrimaryRapidColorHEX, ColorHEX } from '../_common/colors.hex';
import { primaryBlueWebRGBA, primaryPurpleWebRGBA } from '../_config/styles/colors';
export const zeroFlipperStyles = (context, definition) => css `
  ${foundationFlipperStyles(context, definition)}
  :host {
    --foreground-on-accent-rest: ${ColorHEX.white};
    --foreground-on-accent-hover: ${ColorHEX.white};
    --foreground-on-accent-active: ${ColorHEX.white};
    --primary-gradient-angle: -113.5deg;
  }

  :host::before {
    background: linear-gradient(
      var(--primary-gradient-angle),
      ${primaryBlueWebRGBA(0.7)},
      ${primaryPurpleWebRGBA(0.7)}
    );
  }

  :host(:hover)::before {
    background: linear-gradient(
      var(--primary-gradient-angle),
      ${PrimaryRapidColorHEX.blue},
      ${PrimaryRapidColorHEX.purple}
    );
  }
`;
